import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { AuthService } from '../aplication-services/auth.service';

@Injectable({
  providedIn: 'root'
})
export class AccountOwnerGuard {
  constructor(
    private authService: AuthService,
    private router: Router
  ) {}

  canActivate(route: ActivatedRouteSnapshot) {
    const isAccountOwner = this.isAccountOwner(route);
    if (!isAccountOwner) {
      this.navigateToNotFoundPage();
    }
    return this.isAccountOwner(route);
  }

  navigateToNotFoundPage() {
    this.router.navigate(['/not-found']);
  }

  isAccountOwner(route: ActivatedRouteSnapshot): boolean {
    if (!this.authService.isLoggedIn()) return false;
    const username = this.getUsernameFromUrl(route).toLowerCase();
    const currentUserUsername = this.authService.$userStatus.value.username.toLowerCase();
    return username === currentUserUsername;
  }

  private getUsernameFromUrl(route: ActivatedRouteSnapshot): string {
    const username = route.params['username'];
    return username;
  }
}
